const type = "CYCLEREPORT/";

export const cycleReportConstants = {
  CYCLE_REPORT_LISTING_REQUEST: `${type}CYCLE_REPORT_LISTING_REQUEST`,
  CYCLE_REPORT_LISTING_SUCCESS: `${type}CYCLE_REPORT_LISTING_SUCCESS`,
  CYCLE_REPORT_LISTING_FAILURE: `${type}CYCLE_REPORT_LISTING_FAILURE`,

  CYCLE_REPORT_DOWNLOAD_REQUEST: `${type}CYCLE_REPORT_DOWNLOAD_REQUEST`,
  CYCLE_REPORT_DOWNLOAD_SUCCESS: `${type}CYCLE_REPORT_DOWNLOAD_SUCCESS`,
  CYCLE_REPORT_DOWNLOAD_FAILURE: `${type}CYCLE_REPORT_DOWNLOAD_FAILURE`
};
